<div *ngIf="!showGroupButton" class="group-condition-div">
  <button
    class="btn btn-primary rounded-0 group-quota-button basic-button"
    (click)="groupConditions()"
  >
    Group Conditions
  </button>
</div>
<div class="group-button-div" *ngIf="showGroupButton">
  <button
    class="btn btn-primary rounded-0 group-quota-button-default basic-button"
    (click)="groupQuotas()"
  >
    Group
  </button>
  <button
    class="btn btn-primary rounded-0 group-quota-button-default basic-button"
    (click)="cancelGroupConditions()"
  >
    Cancel
  </button>
</div>
<div class="group_quota">
  <div *ngIf="showGroupButton">
    <div class="all-quota" *ngFor="let quota of quotas">
      <div
        *ngIf="quota.oldQuotasText && quota.oldQuotasText.length <= 1"
        class="single-quota"
        [ngClass]="{ 'selected-quota': quota.selectedForGroup }"
        (click)="selectQuota(quota)"
      >
        {{ quota.text }}
      </div>
    </div>
  </div>
</div>
